import React, { useEffect, useState } from "react";
import {
    Card,
    Button,
    InlineStack,
    Text,
    Layout,
    Page,
    Frame
} from "@shopify/polaris";
import { useHistory } from "react-router-dom";
import Api from "../../helpers/api";
import { useToast } from "@shopify/app-bridge-react";
import InventoryOnHandReset from "./components/InventoryOnHandReset";
// import ResetQuantityUnshipped from "./components/ResetQuantityUnshipped"; // hidden per request
import ImportInventory from "./components/ImportInventory";
import ImportImages from "./components/ImportImages";
import ImportB2bPricing from "./components/ImportB2bPricing";

export const productTypes = [
    { label: "Livestock", value: "livestock" },
    { label: "Furnace", value: "furnace" },
    { label: "Dry Goods", value: "dry_goods" },
    { label: "Freshwater", value: "freshwater" },
];

const InventoryPanel = () => {
    const [loading, setLoading] = useState();
    const [selectedProductType, setSelectedProductType] = useState(null);
    const history = useHistory();
    const toast = useToast();
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        setLoading(true);
        Api.getStoreLocations()
            .then(({ data }) => {
                setLocations(data ?? []);
            })
            .catch(() => toast.show("Server error"))
            .finally(() => setLoading(false));
    }, []);

    const availableTypes = productTypes.filter(
        (type) => type.value !== selectedProductType
    );

    return (
        <Frame>
            <Page backAction={() => history.goBack()} title="Inventory Management">
                <Layout sectioned>

                    <Layout.Section>
                        <Card>
                            <div style={{ display: "flex", justifyContent: "space-between", gap: "2rem", flexWrap: "wrap" }}>
                                {/* Reset Quantity Unshipped - hidden per request
                                <div style={{ flex: 1 }}>
                                    <Text as="h3">Reset Quantity Unshipped</Text>
                                    <div style={{ marginTop: 8 }}>
                                        <ResetQuantityUnshipped
                                            loading={loading}
                                            setLoading={setLoading}
                                            disabled={!!selectedProductType}
                                        />
                                    </div>
                                </div>
                                */}
                                <div style={{ flex: 1 }}>
                                    <Text as="h3">Images Import</Text>
                                    <div style={{ marginTop: 8 }}>
                                        <ImportImages
                                            loading={loading}
                                            setLoading={setLoading}
                                            productType={selectedProductType}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Layout.Section>

                    <Layout.Section>
                        <Card>
                            {!selectedProductType ? (
                                <>
                                    <Text variant="headingMd">Select Product Type:</Text>
                                    <InlineStack gap="200" wrap={false} style={{ marginTop: 12 }}>
                                        {productTypes.map((type) => (
                                            <Button
                                                key={type.value}
                                                onClick={() => setSelectedProductType(type.value)}
                                            >
                                                {type.label}
                                            </Button>
                                        ))}
                                    </InlineStack>
                                </>
                            ) : (
                                <>
                                    <Text variant="headingMd">
                                        Product Type: <strong>{productTypes.find(t => t.value === selectedProductType)?.label}</strong>{" "}
                                        <Button plain onClick={() => setSelectedProductType(null)}>change</Button>
                                    </Text>
                                </>
                            )}
                        </Card>
                    </Layout.Section>

                    {selectedProductType && (
                        <Layout.Section>
                            <Card>
                                <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                                    <div>
                                        <Text variant="headingSm">
                                            {productTypes.find(t => t.value === selectedProductType)?.label} - Reset Quantity On Hand
                                        </Text>
                                        <InventoryOnHandReset
                                            locations={locations}
                                            loading={loading}
                                            setLoading={setLoading}
                                            productType={productTypes.find(p => p.value === selectedProductType)}
                                        />
                                    </div>

                                    <div>
                                        <Text variant="headingSm">
                                            {productTypes.find(t => t.value === selectedProductType)?.label} - Replace Inventory with CSV
                                        </Text>
                                        <ImportInventory
                                            locations={locations}
                                            loading={loading}
                                            setLoading={setLoading}
                                            productType={productTypes.find(p => p.value === selectedProductType)}
                                            mode="replace"
                                        />
                                    </div>

                                    <div>
                                        <Text variant="headingSm">
                                            {productTypes.find(t => t.value === selectedProductType)?.label} - Add Inventory with CSV
                                        </Text>
                                        <ImportInventory
                                            locations={locations}
                                            loading={loading}
                                            setLoading={setLoading}
                                            productType={productTypes.find(p => p.value === selectedProductType)}
                                            mode="add"
                                        />
                                    </div>

                                    <div>
                                        <Text variant="headingSm">
                                            {productTypes.find(t => t.value === selectedProductType)?.label} - Import Specials with CSV
                                        </Text>
                                        <ImportB2bPricing
                                            loading={loading}
                                            setLoading={setLoading}
                                            productType={productTypes.find(p => p.value === selectedProductType)}
                                        />
                                    </div>
                                </div>
                            </Card>
                        </Layout.Section>
                    )}

                </Layout>
            </Page>
        </Frame>
    );
};

export default InventoryPanel;
